export default __webpack_public_path__ + "static/media/hotService2.7f7cb58a.svg";